<template>
	<div class="container">
    <p v-lang.line1></p><br>
    <p v-lang.line2></p>
		<form action="/cgi-bin/mailmanager.pl" method="POST" v-on:submit="submit" id="prospekt">
              <input type=hidden name="recipient" value="info@schuett-biotec.de"> <input type=hidden name="subject" value="Prospekt-Bestellung über www.schuett-biotec.de (D)">
              <table border=0 cellspacing=0 cellpadding=0 width=488>
                <tr align=LEFT valign=TOP>
                  <td width="91"><p v-lang.name></p></td>
                  <td width=397>
                    <input id="realname" type="text" name="firma" value="" size=55 maxlength=60>
                  </td>
                </tr>
                <tr valign="top" align="left">
                  <td width=91>
                    <p v-lang.institut></p>
                  </td>
                  <td width=397>
                    <input id="FormularTextfeld5" type="text" name="institut" value="" size=55 maxlength=60>
                  </td>
                </tr>
                <tr valign="top" align="left">
                  <td width=91>
                    <p v-lang.abteilung></p>
                  </td>
                  <td width=397>
                    <input id="FormularTextfeld9" type="text" name="abteilung" value="" size=55 maxlength=60>
                  </td>
                </tr>
                <tr valign="top" align="left">
                  <td width=91>
                    <p v-lang.strasse></p>
                  </td>
                  <td width=397>
                    <input id="FormularTextfeld6" type="text" name="strasse" value="" size=55 maxlength=60>
                  </td>
                </tr>
                <tr valign="top" align="left">
                  <td width=91>
                    <p v-lang.postal></p>
                  </td>
                  <td width=397>
                    <input id="FormularTextfeld7" type="text" name="plz_ort" value="" size=55 maxlength=60>
                  </td>
                </tr>
                <tr valign="top" align="left">
                  <td width=91>
                    <p v-lang.country></p>
                  </td>
                  <td width=397>
                    <input type="text" name="country" size="55" maxlength="60" value="">
                  </td>
                </tr>
                <tr valign="top" align="left">
                  <td width=91>
                    <p v-lang.email></p>
                  </td>
                  <td width=397>
                    <input id="email" type="text" name="email" value="" size=55 maxlength=60>
                    <p></p>
                  </td>
                </tr>
                <tr valign="top" align="left">
                  <td width=91>
                    <p v-lang.website></p>
                  </td>
                  <td width=397>
                    <input id="website" type="url" name="website" placeholder="https://example.com" pattern="https://.*" value="" size=55 maxlength=60>
                    <p></p>
                  </td>
                </tr>
              </table>
              <p><input type="reset" name="ularSchaltfläche2" value="Del" id="FormularSchaltfläche2"> <input type="submit" name="send-button" value="Send" id="FormHandler6"></p>
            </form>
	</div>
</template>
<script>
export default {
    name: 'prospektform',
    data () {
      return {}
    },
    methods: {
      postAjax: function (url, data, success) {
        var params = typeof data == 'string' ? data : Object.keys(data).map(
          function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
        ).join('&')

        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP")
        xhr.open('POST', url)
        xhr.onreadystatechange = function() {
            if ( xhr.readyState > 3 && xhr.status === 200) { success(xhr.responseText) }
        }
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        xhr.send(params)
        return xhr
      },
      submit: function (event) {
        var form = document.getElementById('prospekt')
        var FD = new FormData(form)
        this.postAjax(form.getAttribute('action'), FD, function (text) {
          console.log(text)
        })
    }
  },
  messages: {
    de: {
      line1: "Sie sind an unseren Produkten interessiert?",
      line2: "Gerne senden wir ihnen unsere Prospektmappe zu.",
      name: "Firma",
      institut: "Institut",
      abteilung: 'Abteilung',
      strasse: 'Straße',
      postal: 'PLZ/Ort',
      tel: 'Telefon Nr.',
      fax: 'Telefax Nr.',
      email: 'E-Mail',
      website: 'Website',
      country: 'Land'
    },
    en: {
      line1: "You are interested in our product range?",
      line2: "It would be our pleasure to send you our catalogue.",
      name: "Company",
      institut: "Institute",
      abteilung: 'Department',
      strasse: 'Street',
      postal: 'Post code/City',
      tel: 'Telefon Nr.',
      fax: 'Telefax Nr.',
      email: 'E-Mail',
      website: 'Website',
      country: 'Country'
    }
  }
};
</script>
<style scoped>
	.container {
    color: black;
    margin: 1rem;
  }
  #prospekt {
    padding-top: 2em;
    padding-left: 2rem;
  }
  td {
    border: none;
    text-align: left;
  }
  tr {
    padding-top: 2px;
    padding-bottom: 2px;
  }
  form > table {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/prospektform.vue